import axios from 'axios'
import alert from '@/lib/alert'

export default {
  namespaced: true,
  state: {
    userId: null,
    searchInput: false,
    searchQuery: '',
    searchResult: [],
    searching: false,
    showResultsBox: false
  },
  mutations: {
    OPEN_SEARCH_INPUT: (state) => {
      state.searchInput = true;
    },
    CLOSE_SEARCH_INPUT: (state) => {
      state.searchInput = false;
    },
    START_LOADING: (state) => {
      state.searching = true;
    },
    RESULTS_LOADED: (state, result) => {
      state.searchResult = result.matching;
      state.userId = result.userId;
      state.searching = false;
    },
    SHOW_RESULT_BOX: (state) => {
      state.showResultsBox = true;
    },
    CLOSE_RESULT_BOX: (state) => {
      state.showResultsBox = false;
    },
    CLOSE_CLEAR_RESULTS: (state) => {
      state.searchResult = [];
    },
    DELETE_FROM_RESULTS: (state, shortId) => {
      let dialogIndex = state.searchResult.findIndex(dialog => {
        return dialog.shortId == shortId;
      })
      state.searchResult.splice(dialogIndex, 1);
    },
    SET_QUERY: (state, query) => {
      state.searchQuery = query;
    }
  },
  actions: {
    openSearchInput: ({commit}) => {
      commit('OPEN_SEARCH_INPUT');
    },
    closeSearchInput: ({commit}) => {
      commit('CLOSE_SEARCH_INPUT');
    },
    searchDialog: ({commit}, query) => {
      commit('SET_QUERY', query);
      commit('START_LOADING');
      commit('SHOW_RESULT_BOX');
      axios({
        method: 'post',
        url: `${process.env.VUE_APP_SERVER_URL}searchDialog`,
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token') 
        },
        data: {
          query
        }
      }).then(result => {
        commit('RESULTS_LOADED', result.data);
      }).catch(err => {
        console.log(err);
        alert.showError(err);
      })
    },
    closeSearch: ({commit}) => {
      commit('CLOSE_RESULT_BOX');
      commit('CLOSE_CLEAR_RESULTS');
    },
    deleteFromResults: ({commit}, shortId) => {
      commit('DELETE_FROM_RESULTS', shortId);
    }
  },
  getters: {
    getSearchInputState: (state) => {
      return state.searchInput;
    },  
    getResult: (state) => {
      return state.searchResult;
    },
    getSearching: (state) => {
      return state.searching;
    },
    getShowResultBox: (state) => {
      return state.showResultsBox;
    },
    getUserId: (state) => {
      return state.userId;
    },
    getSearchQuery: (state) => {
      return state.searchQuery;
    }
  }
}